import OneClickOfferCardWeb from "./OneClickOfferCardWeb";

export default OneClickOfferCardWeb;
